<template>
  <Root :disabled="!planRequired">
    <Trigger>
      <slot :plan-required="planRequired" :redirect="redirect"></slot>
    </Trigger>

    <Content v-if="planRequired" side="left">
      Upgrade to {{ planRequired.name }} to unlock this
    </Content>
  </Root>
</template>

<script setup lang="ts">
import { toRef } from "vue";
import { useRouter } from "vue-router";

import type { Feature } from "@/screens/billing/lib";
import { useFeatureRequirement } from "@/store/stores/account";

import Content from "./Content.vue";
import Root from "./Root.vue";
import Trigger from "./Trigger.vue";

const router = useRouter();

const props = defineProps<{
  feature: Feature;
}>();

const planRequired = useFeatureRequirement(toRef(props, "feature"));

const redirect = () => {
  router.push({ name: "/settings/billing" });
};
</script>
